import React from 'react';
import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div style={s.page}>
      <div style={s.container}>

        {/* Header */}
        <div style={s.header}>
          <Link to="/" style={s.back}>← Back to App</Link>
          <h1 style={s.title}>📋 Terms of Service</h1>
          <p style={s.sub}>சேவை விதிமுறைகள் | Effective: April 2026</p>
        </div>

        {/* Highlight box */}
        <div style={s.highlight}>
          By using JSMSTOCK, you agree to these terms. Please read carefully before using our service.
        </div>

        {/* Section 1 */}
        <h2 style={s.h2}>1. About JSMSTOCK</h2>
        <p style={s.p}>
          JSMSTOCK is a Software-as-a-Service (SaaS) product designed for Tamil Nadu shop owners.
          We provide stock management, GST billing, invoicing, and business management tools.
        </p>
        <ul style={s.ul}>
          <li>Email: support@jsmstock.com</li>
          <li>Phone: +91-9159933276 (6PM–9PM, Mon–Sat)</li>
          <li>Website: https://jsmstock.com</li>
          <li>Location: Madurai, Tamil Nadu, India</li>
        </ul>

        {/* Section 2 */}
        <h2 style={s.h2}>2. Eligibility</h2>
        <p style={s.p}>To use JSMSTOCK, you must:</p>
        <ul style={s.ul}>
          <li>Be at least 18 years of age</li>
          <li>Be a legitimate business owner or authorized representative</li>
          <li>Provide accurate and complete registration information</li>
          <li>Have a valid mobile number and/or email address</li>
        </ul>

        {/* Section 3 */}
        <h2 style={s.h2}>3. Subscription & Pricing</h2>

        <h3 style={s.h3}>3.1 Free Trial</h3>
        <ul style={s.ul}>
          <li>Every new user gets <strong>30 days FREE trial</strong></li>
          <li>No credit card or payment required during trial</li>
          <li>Full access to all features during trial period</li>
          <li>Trial automatically ends after 30 days</li>
        </ul>

        <h3 style={s.h3}>3.2 Paid Subscription</h3>
        <ul style={s.ul}>
          <li>After trial: <strong>Rs.299/month</strong> per account</li>
          <li>Payment via UPI, Bank Transfer, or Online payment</li>
          <li>Account activated within 30 minutes of payment receipt</li>
        </ul>

        <h3 style={s.h3}>3.3 Price Changes</h3>
        <ul style={s.ul}>
          <li>We may change pricing with 30-day advance notice</li>
          <li>Existing subscribers notified via WhatsApp/Email</li>
        </ul>

        {/* Section 4 */}
        <h2 style={s.h2}>4. Acceptable Use</h2>
        <p style={s.p}>You must NOT:</p>
        <ul style={s.ul}>
          <li>Use JSMSTOCK for illegal or unauthorized purposes</li>
          <li>Share account credentials with unauthorized persons</li>
          <li>Attempt to gain unauthorized access to our systems</li>
          <li>Upload malicious code or harmful content</li>
          <li>Resell or redistribute the service without permission</li>
        </ul>

        {/* Section 5 */}
        <h2 style={s.h2}>5. Data & Privacy</h2>
        <ul style={s.ul}>
          <li>You own all data you enter into JSMSTOCK</li>
          <li>We do not sell or share your data with third parties</li>
          <li>Data stored on AWS India (Mumbai) secure servers</li>
          <li>All connections use HTTPS encryption</li>
          <li>Passwords hashed with bcrypt (never stored in plain text)</li>
        </ul>

        {/* Section 6 — Important */}
        <h2 style={s.h2}>6. Limitation of Liability</h2>
        <div style={s.warning}>
          <strong>⚠️ Important Disclaimer:</strong>
          <ul style={{...s.ul, marginTop:'8px'}}>
            <li>JSMSTOCK is a <strong>tool</strong> — not financial or legal advice</li>
            <li>We are not responsible for GST filing accuracy</li>
            <li>We are not responsible for business decisions based on app data</li>
            <li>We are not responsible for data loss due to unforeseen circumstances</li>
            <li>Maximum liability = Last 3 months subscription amount paid</li>
          </ul>
        </div>

        {/* Section 7 */}
        <h2 style={s.h2}>7. Service Availability</h2>
        <ul style={s.ul}>
          <li>We target 99% uptime but cannot guarantee uninterrupted service</li>
          <li>Support hours: 6PM–9PM, Monday–Saturday (IST)</li>
          <li>Scheduled maintenance announced 24 hours in advance</li>
        </ul>

        {/* Section 8 */}
        <h2 style={s.h2}>8. Termination</h2>
        <ul style={s.ul}>
          <li>You may stop using the service at any time</li>
          <li>We may terminate accounts that violate these Terms</li>
          <li>Account data retained for 90 days after cancellation</li>
          <li>Non-payment for 30+ days results in account suspension</li>
        </ul>

        {/* Section 9 */}
        <h2 style={s.h2}>9. Intellectual Property</h2>
        <ul style={s.ul}>
          <li>JSMSTOCK software, code, and design are our property</li>
          <li>You may not copy or distribute JSMSTOCK without permission</li>
          <li>'JSMSTOCK' name and logo are proprietary trademarks</li>
          <li>Your business data remains your property</li>
        </ul>

        {/* Section 10 */}
        <h2 style={s.h2}>10. Governing Law</h2>
        <ul style={s.ul}>
          <li>Governed by laws of India</li>
          <li>Jurisdiction: Courts in Madurai, Tamil Nadu, India</li>
          <li>Disputes first resolved through WhatsApp/Email</li>
          <li>Consumer Forum: Madurai District Consumer Forum</li>
        </ul>

        {/* Footer links */}
        <div style={s.legalLinks}>
          <Link to="/terms"   style={s.llink}>Terms of Service</Link>
          <span style={s.sep}>|</span>
          <Link to="/privacy" style={s.llink}>Privacy Policy</Link>
          <span style={s.sep}>|</span>
          <Link to="/refund"  style={s.llink}>Refund Policy</Link>
        </div>

        <p style={s.copy}>© 2026 JSMSTOCK | Madurai, Tamil Nadu | support@jsmstock.com</p>
      </div>
    </div>
  );
}

const s = {
  page:{background:'#f5f6fa',minHeight:'100vh',padding:'20px 16px'},
  container:{maxWidth:'800px',margin:'0 auto',background:'white',borderRadius:'12px',padding:'32px',boxShadow:'0 2px 12px rgba(0,0,0,0.08)'},
  header:{marginBottom:'24px',paddingBottom:'20px',borderBottom:'3px solid #2C3E50'},
  back:{color:'#3498DB',textDecoration:'none',fontSize:'14px',fontWeight:'600'},
  title:{color:'#2C3E50',margin:'12px 0 4px',fontSize:'26px',fontWeight:'900'},
  sub:{color:'#888',margin:0,fontSize:'14px'},
  highlight:{background:'#FFF9E6',border:'1px solid #C9A84C',borderLeft:'5px solid #C9A84C',padding:'14px 16px',borderRadius:'6px',marginBottom:'24px',fontSize:'14px',color:'#856404',fontWeight:'600'},
  h2:{color:'#2C3E50',fontSize:'18px',fontWeight:'800',marginTop:'28px',marginBottom:'8px',paddingBottom:'6px',borderBottom:'2px solid #EEE'},
  h3:{color:'#3498DB',fontSize:'15px',fontWeight:'700',marginTop:'16px',marginBottom:'6px'},
  p:{color:'#444',fontSize:'14px',lineHeight:'1.7',marginBottom:'8px'},
  ul:{color:'#444',fontSize:'14px',lineHeight:'2',marginBottom:'8px',paddingLeft:'20px'},
  warning:{background:'#FFF5F5',border:'1px solid #E74C3C',borderLeft:'5px solid #E74C3C',padding:'14px 16px',borderRadius:'6px',fontSize:'14px',color:'#C0392B'},
  legalLinks:{display:'flex',justifyContent:'center',gap:'8px',marginTop:'40px',padding:'16px',background:'#F8F9FA',borderRadius:'8px'},
  llink:{color:'#3498DB',textDecoration:'none',fontSize:'13px',fontWeight:'600'},
  sep:{color:'#CCC'},
  copy:{textAlign:'center',color:'#999',fontSize:'12px',marginTop:'12px'},
};
